/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Box, Container, Typography, IconButton, Collapse } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'store';
import { notificationAPI } from 'store/slices/announcement.slice';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify'
import { goScrollTop } from 'utils/windows';

const Wrapper = styled(Box)(({ theme }) => ({
    background: theme.palette.primary.dark,
    position: 'relative'
}));

const StyledContainer = styled(Container)({
    display: 'flex',
    alignItems: 'center',
    padding: '10px 30px',
    color: 'white'
});

const StyledTypo = styled(Typography)({
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '160%',
    paddingLeft: '10px'
});

function AnnouncementMessage() {
    const [counter, setCounter] = useState<number>(0);
    const [isClosed, setClose] = useState(false);
    const dispatch = useDispatch();
    const notificationData = useSelector((state) => state.announcement);
    const options = {
        replace: (domNode: any) => {
            if (domNode.attribs && domNode.name === 'a') {
                domNode.attribs.target = '_blank';
            }
        }
    };
    const announcement = parse(DOMPurify.sanitize(notificationData?.data[counter]?.Title ?? ''), options);

    function getNotification() {
        dispatch(notificationAPI());
    }

    const handleCloseNotification = () => {
        setClose(true);
    };
    useEffect(() => {
        getNotification();
        goScrollTop();
    }, []);

    useEffect(() => {
        const carouselCounter = () => {
            if (counter + 1 < notificationData.data.length) {
                setCounter(counter + 1);
            }
            if (counter + 1 === notificationData.data.length) {
                setCounter(0);
            }
        };

        const interval = setInterval(() => {
            carouselCounter();
        }, 5000);

        return () => clearInterval(interval);
    }, [counter, notificationData.data.length]);

    if (notificationData.data.length === 0) return null;

    return (
        <Wrapper>
            <Collapse in={!isClosed} data-testid="CollapsedContainer">
                <StyledContainer>
                    <InfoRoundedIcon style={{ minWidth: '30px' }} />
                    <StyledTypo>{announcement}</StyledTypo>
                    <IconButton onClick={handleCloseNotification} sx={{ marginLeft: 'auto' }} data-testid="closeButton" aria-label="closebtn">
                        <CloseRoundedIcon sx={{ color: 'white' }} />
                    </IconButton>
                </StyledContainer>
            </Collapse>
        </Wrapper>
    );
}

export default AnnouncementMessage;
